"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Checkout = void 0;
var api_helper_const_1 = require("@const/api-helper.const");
var helper_const_1 = require("@const/helper.const");
var input_output_helper_const_1 = require("@const/input-output-helper.const");
var reference_object_const_1 = require("@const/reference-object.const");
var object_service_1 = require("@services/object-service");
var settings_service_1 = require("@services/settings.service");
var translation_1 = __importDefault(require("@services/translation"));
var generator_const_1 = require("@src/const/dom-crud/generator.const");
var inter_communication_service_1 = require("@src/services/inter-communication.service");
var cash_dom_1 = __importDefault(require("cash-dom"));
var lodash_1 = __importDefault(require("lodash"));
var get_1 = __importDefault(require("lodash/get"));
var term_switcher_1 = require("./term-switcher");
var membership_localstorage_const_1 = require("./membership-localstorage.const");
var tracker_service_1 = require("@src/services/tracker.service");
var Checkout = /** @class */ (function () {
    function Checkout() {
        this.config = object_service_1.ObjectService.getInstance(settings_service_1.SettingsService);
        this.communicationService = object_service_1.ObjectService.getInstance(inter_communication_service_1.InterCommunicationService);
        this.trackerService = object_service_1.ObjectService.getInstance(tracker_service_1.TrackerService);
        this.termSwitcher = new term_switcher_1.TermSwitcher();
        this.backupOfferings = [];
        this.offerings = [];
        this.initDone = false;
    }
    Checkout.prototype.loadModule = function () {
        return __awaiter(this, void 0, void 0, function () {
            var studioData;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        //NOTE: Seems like this is no longer in use???
                        // this.maximumNumberOfOfferings =
                        //   this.config.get?.modules?.maximumNumberOfOfferings ||
                        //   this.config.get?.checkout?.maximumNumberOfOfferings ||
                        //   this.maximumNumberOfOfferings;
                        console.log('module', this.module, 'refs', this.module.references);
                        if (this.config.get.environment === 'dev') {
                            console.info('If you want to use directly the magicline contract object just define some parent object as [data-membership="<<CONTRACTID>>OR<<CONTRACTNAME>>"] OR ', 'And than you can use in the children e.g. custom attributes like [data-get="price"]');
                        }
                        this.communicationService.subscribeGlobally().subscribe(function (data) { return __awaiter(_this, void 0, void 0, function () {
                            var studioData_1;
                            var _a;
                            return __generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0:
                                        if (!(data.event === 'custom' && ((_a = data.module) === null || _a === void 0 ? void 0 : _a.moduleKey) === 'studio-selection' && data.name === 'studioSelected')) return [3 /*break*/, 5];
                                        console.log('User selected studio while a membership selection module exists', data);
                                        return [4 /*yield*/, (0, api_helper_const_1._GetOfferings)()];
                                    case 1:
                                        studioData_1 = _b.sent();
                                        if (!studioData_1) {
                                            console.error('got no offerings');
                                            return [2 /*return*/];
                                        }
                                        else {
                                            console.log('got offerings: ', studioData_1);
                                        }
                                        this.backupOfferings = lodash_1.default.cloneDeep(studioData_1.offerings);
                                        this.offerings = lodash_1.default.cloneDeep(this.backupOfferings);
                                        if (!!this.initDone) return [3 /*break*/, 3];
                                        this.doInit();
                                        return [4 /*yield*/, this.reloadAndRenderAllContracts()];
                                    case 2:
                                        _b.sent();
                                        this.prepareMembershipSubmitButton();
                                        this.initDone = true;
                                        return [3 /*break*/, 5];
                                    case 3:
                                        // refresh term switcher
                                        this.termSwitcher.loadModule(this.offerings);
                                        return [4 /*yield*/, this.reloadAndRenderAllContracts()];
                                    case 4:
                                        _b.sent();
                                        _b.label = 5;
                                    case 5: return [2 /*return*/];
                                }
                            });
                        }); });
                        return [4 /*yield*/, (0, api_helper_const_1._GetOfferings)()];
                    case 1:
                        studioData = _a.sent();
                        if (!studioData) {
                            console.error('got no offerings');
                            return [2 /*return*/];
                        }
                        else {
                            console.log('got offerings: ', studioData);
                        }
                        this.backupOfferings = lodash_1.default.cloneDeep(studioData.offerings);
                        this.offerings = lodash_1.default.cloneDeep(this.backupOfferings);
                        //prepare term switcher
                        this.doInit();
                        return [4 /*yield*/, this.reloadAndRenderAllContracts()];
                    case 2:
                        _a.sent();
                        this.prepareMembershipSubmitButton();
                        this.initDone = true;
                        return [2 /*return*/];
                }
            });
        });
    };
    Checkout.prototype.doInit = function () {
        var _this = this;
        //prepare term switcher
        this.termSwitcher.$container = this.$container;
        this.termSwitcher.module = this.module;
        this.termSwitcher.loadModule(this.offerings);
        this.termSwitcher.termChanged.subscribe(function (newTerm) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.dataWrapper = this.$container.find('[data-wrapper="' + newTerm + '"]');
                console.log('NEW TERM', newTerm, this.dataWrapper);
                this.reloadAndRenderAllContracts();
                return [2 /*return*/];
            });
        }); });
    };
    /**
     * If you click on a membership
     * TODO: Seems to be an edge case, since the submitbutton is generated usually
     * Seems to be deprecated ? does not set selected offering data, so sendForm() fails
     */
    Checkout.prototype.prepareMembershipSubmitButton = function () {
        var _this = this;
        var _a, _b;
        var membershipButton = (_b = (_a = this.module.references) === null || _a === void 0 ? void 0 : _a.membershipSubmit) === null || _b === void 0 ? void 0 : _b.domElement;
        if (membershipButton) {
            //remove eventual default events on the button
            membershipButton.off();
            //save membership info continue with next section
            membershipButton.on('click', function (event) {
                _this.sendForm(event);
            });
        }
    };
    /**
     * Removes and renders all contracts
     *   1. resets offerings
     *   2. filters contracts by term switcher
     *   3. sorts contracts
     *   4. fills / sets data accordingly
     */
    Checkout.prototype.reloadAndRenderAllContracts = function () {
        return __awaiter(this, void 0, void 0, function () {
            var filteredOfferings;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.offerings = lodash_1.default.cloneDeep(this.backupOfferings);
                        console.log('Reloading offerings:', this.offerings);
                        filteredOfferings = this.termSwitcher.filterOfferingsAndTermsBySwitcherValue(this.offerings);
                        console.log('Got filtered offerings by term switcher to render', filteredOfferings);
                        this.renderContracts(filteredOfferings);
                        this.sortOfferingsBasedOnPrio();
                        return [4 /*yield*/, this.filloutOfferingData(this.offerings)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Checkout.prototype.userSelectedOffering = function (offering, term) {
        return __awaiter(this, void 0, void 0, function () {
            var e_1;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        console.log('User selected offering', offering, term);
                        this.selectedTerm = term;
                        this.selectedOffering = offering;
                        this.updateLocalStorageItems();
                        (0, input_output_helper_const_1._PrefillHiddenFields)();
                        this.communicationService.sendEvent({
                            event: 'custom',
                            module: this,
                            name: 'membershipSelected',
                            value: true,
                        });
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.trackerService.trackFunnelEvent(this.config, 'membershipSelected')];
                    case 2:
                        _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _b.sent();
                        console.error('membershipSelected tracking failed', e_1);
                        return [3 /*break*/, 4];
                    case 4:
                        // TODO: make V2 compatible
                        if ((_a = this.$container.find('#Membership-Submit')) === null || _a === void 0 ? void 0 : _a.length) {
                            console.log('Scrolling to elements', this.$container.find('#Membership-Submit'));
                            (0, helper_const_1._ScrollToPageElement)(this.$container.find('#Membership-Submit'), 1000);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    Checkout.prototype.sendForm = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b, _c;
            return __generator(this, function (_d) {
                if (event) {
                    event.preventDefault();
                    event.stopImmediatePropagation();
                }
                if (this.selectedOffering && this.selectedTerm) {
                    (0, generator_const_1._HideErrorMessage)();
                    this.updateLocalStorageItems();
                    if (!((_b = (_a = this.config.get) === null || _a === void 0 ? void 0 : _a.checkout) === null || _b === void 0 ? void 0 : _b.noRedirect)) {
                        window.location.href = (_c = this.config.get.redirect) !== null && _c !== void 0 ? _c : '/membership/personliche-daten';
                        return [2 /*return*/, true];
                    }
                }
                else {
                    (0, generator_const_1._ShowErrorMessage)(translation_1.default.t('selectContract'));
                    console.error('No Offering selected', this.selectedOffering, this.selectedTerm);
                    return [2 /*return*/, false];
                }
                return [2 /*return*/];
            });
        });
    };
    Checkout.prototype.updateLocalStorageItems = function () {
        var _a, _b;
        (0, membership_localstorage_const_1.setMembershipLocalstorage)(this.selectedOffering, this.selectedTerm);
        // move optional modules to selected modules in local storage
        // if (this.config.get?.checkout?.optionalModulesAreAlwaysSelected || this.config.get?.technologyType === 'yond') {
        //   localStorage.setItem('optionalModules', JSON.stringify(this.selectedTerm.optionalModules?.map((module) => module.id)));
        // }
        if ((_b = (_a = this.config.get) === null || _a === void 0 ? void 0 : _a.checkout) === null || _b === void 0 ? void 0 : _b.callback) {
            this.config.get.checkout.callback({
                offerings: this.offerings,
                selectedOffering: this.selectedOffering,
                selectedTerm: this.selectedTerm,
            });
        }
    };
    /**
     * adds subdescription entries for a given contract
     * @param subDescription subdescription of offering
     * @param htmlEle where to add subdescriptions
     */
    Checkout.prototype.createSubDescriptionRefObject = function (subDescription, htmlEle) {
        var _a, _b, _c, _d, _e;
        if ((_c = (_b = (_a = this.module.references) === null || _a === void 0 ? void 0 : _a.subdescription) === null || _b === void 0 ? void 0 : _b.domElement) === null || _c === void 0 ? void 0 : _c.length) {
            var subdescriptionRef = this.module.references.subdescription;
            htmlEle.html('');
            var entries = subDescription.replace(/\*/gi, '').split('\n');
            console.log('Generating subdescription using base-ref', subdescriptionRef, 'and entries', entries);
            for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
                var entry = entries_1[_i];
                var copyOfSubdescription = subdescriptionRef.cloneDomElement();
                var replaceText = copyOfSubdescription.find('[data-get="item"]');
                ((replaceText === null || replaceText === void 0 ? void 0 : replaceText.length) ? replaceText : copyOfSubdescription).html(entry.replace(/^[*\-\s]*/gi, '').trim());
                htmlEle.append(copyOfSubdescription);
            }
        }
        else {
            if (this.config.get.environment === 'dev') {
                console.error("Failed to find a subdescription reference with data-ref='" + ((_e = (_d = this.module.references) === null || _d === void 0 ? void 0 : _d.subdescription) === null || _e === void 0 ? void 0 : _e.uid) + "'");
            }
            htmlEle.html(subDescription); // plain subdescription unformatted
        }
    };
    /**
     * Typically we want to have featured ref object ids to the right of regular contracts
     */
    Checkout.prototype.sortOfferingsBasedOnPrio = function () {
        var _a, _b, _c, _d;
        var featuredCard = this.$container.find('[data-featured="true"]');
        if (!(featuredCard === null || featuredCard === void 0 ? void 0 : featuredCard.length))
            return;
        var parent = featuredCard.parent();
        if (!(parent === null || parent === void 0 ? void 0 : parent.length))
            return;
        var totalChildren = parent.children().length;
        if (totalChildren < 2)
            return;
        var position = (_d = (_c = (_b = (_a = this.config) === null || _a === void 0 ? void 0 : _a.get) === null || _b === void 0 ? void 0 : _b.checkout) === null || _c === void 0 ? void 0 : _c.featuredContractPosition) !== null && _d !== void 0 ? _d : 'middle';
        switch (position) {
            case 'start':
                parent.prepend(featuredCard);
                break;
            case 'end':
                parent.append(featuredCard);
                break;
            case 'middle':
            default: {
                var middleIndex = Math.floor(totalChildren / 2);
                parent
                    .children()
                    .eq(middleIndex - 1)
                    .after(featuredCard);
                break;
            }
        }
    };
    /**
     * brings the simple clones / panes to live by filling out the data
     */
    Checkout.prototype.filloutOfferingData = function (offerings) {
        return __awaiter(this, void 0, void 0, function () {
            var numberOfClickablePanes, getOfferingPanes, _loop_1, this_1, _i, getOfferingPanes_1, offeringPane;
            var _this = this;
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
            return __generator(this, function (_u) {
                numberOfClickablePanes = 0;
                getOfferingPanes = this.$container.find('[data-membership]').get();
                _loop_1 = function (offeringPane) {
                    var membershipId = offeringPane.getAttribute('data-membership');
                    var termId = offeringPane.getAttribute('data-term-id');
                    var offering = offerings.find(function (a) {
                        return a.terms.some(function (b) { return String(b.id) === String(membershipId); }) ||
                            String(a.id) === String(membershipId) ||
                            a.name.toLowerCase() === membershipId.toLowerCase();
                    });
                    if (offering === undefined) {
                        console.error('No contract for requested membership gonna hide membership offering', membershipId, offering);
                        if (((_b = (_a = this_1.config.get) === null || _a === void 0 ? void 0 : _a.checkout) === null || _b === void 0 ? void 0 : _b.modeIfNoContractIsSet) === 'hideSubmit') {
                            var submitButton_1 = offeringPane.querySelector('[data-submitbutton="true"]');
                            if (submitButton_1) {
                                submitButton_1.style.display = 'none';
                            }
                        }
                        else {
                            offeringPane.style.display = 'none';
                        }
                        return "continue";
                    }
                    var term = offering.terms.find(function (a) {
                        return String(a.id) === termId || String(a.id) === membershipId || String(a === null || a === void 0 ? void 0 : a.name).toLowerCase() === membershipId.toLowerCase();
                    });
                    if (!term) {
                        console.warn('No term found for id', termId, 'and membership', membershipId, 'in terms', offering.terms);
                    }
                    //NOTE THIS HAS TO BE IMPLEMENTED
                    // if (term === undefined) {
                    //   if (this.termSwitcherValue?.length) {
                    //     term = offering.terms.find((a) =>
                    //       String(a[this.termDefaultKeyForSwitcher]).includes(
                    //         this.termSwitcherValue
                    //       )
                    //     );
                    //     console.log(
                    //       'Find offering based on ',
                    //       this.termSwitcherValue,
                    //       this.termDefaultKeyForSwitcher
                    //     );
                    //   }
                    //   if (term === undefined) {
                    //     term = offering.terms[0];
                    //     console.error(
                    //       'This offering has not the desired term',
                    //       offering,
                    //       this.termSwitcherValue
                    //     );
                    //   }
                    // }
                    // data clickable is just the selection of the contract and not the submition <- currently does nothing
                    // submit the contract using a data-submitbutton on a button or pane
                    // if (offeringPane.getAttribute('data-clickable')) {
                    //   numberOfClickablePanes++;
                    // }
                    var submitButton = offeringPane.querySelector('[data-submitbutton]');
                    if (submitButton) {
                        submitButton.addEventListener('click', function () { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, this.userSelectedOffering(offering, term)];
                                    case 1:
                                        _a.sent();
                                        this.sendForm();
                                        return [2 /*return*/];
                                }
                            });
                        }); });
                    }
                    else {
                        offeringPane.addEventListener('click', function (event) { return __awaiter(_this, void 0, void 0, function () {
                            var _a;
                            return __generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0:
                                        this.$container.find('[data-clickable]').removeAttr('selected-term');
                                        (_a = event === null || event === void 0 ? void 0 : event.currentTarget) === null || _a === void 0 ? void 0 : _a.setAttribute('selected-term', 'true');
                                        return [4 /*yield*/, this.userSelectedOffering(offering, term)];
                                    case 1:
                                        _b.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); });
                    }
                    var multiplier = (_g = (_e = (_d = (_c = this_1.config.get) === null || _c === void 0 ? void 0 : _c.pricePreview) === null || _d === void 0 ? void 0 : _d.paymentFrequencyMultipliers) === null || _e === void 0 ? void 0 : _e[(_f = term === null || term === void 0 ? void 0 : term.id) === null || _f === void 0 ? void 0 : _f.toString()]) !== null && _g !== void 0 ? _g : 1;
                    var adjustment = (_k = (_j = (_h = this_1.config.get) === null || _h === void 0 ? void 0 : _h.checkout) === null || _j === void 0 ? void 0 : _j.displayPriceAdjustment) !== null && _k !== void 0 ? _k : 0;
                    var multipliedTermPaymentFrequency = term.paymentFrequencyValue * multiplier;
                    var multipliedTermPrice = term.price * multiplier + adjustment;
                    var mapping = {
                        name: offering.name,
                        price: translation_1.default.transformCurrency(multipliedTermPrice),
                        currency: translation_1.default.t(term.currencyCode),
                        interval: term.termValue + ' ' + translation_1.default.t(term.termValue > 1 ? term.termUnit + 'S' : term.termUnit),
                        termPaymentFrequency: (multipliedTermPaymentFrequency === 1 ? translation_1.default.t('per') : multipliedTermPaymentFrequency) +
                            ' ' +
                            translation_1.default.t(multipliedTermPaymentFrequency > 1 ? term.paymentFrequencyUnit + 'S' : term.paymentFrequencyUnit),
                    };
                    // name replacements (should not be affected by term switcher)
                    if (Array.isArray((_m = (_l = this_1.config.get) === null || _l === void 0 ? void 0 : _l.checkout) === null || _m === void 0 ? void 0 : _m.replaceTermName) && ((_q = (_p = (_o = this_1.config.get) === null || _o === void 0 ? void 0 : _o.checkout) === null || _p === void 0 ? void 0 : _p.replaceTermName) === null || _q === void 0 ? void 0 : _q.length) > 0) {
                        for (var _v = 0, _w = (_s = (_r = this_1.config.get) === null || _r === void 0 ? void 0 : _r.checkout) === null || _s === void 0 ? void 0 : _s.replaceTermName; _v < _w.length; _v++) {
                            var replacement = _w[_v];
                            mapping.name = (_t = mapping.name) === null || _t === void 0 ? void 0 : _t.replace(replacement, '');
                        }
                    }
                    console.log('Offering mapping', mapping);
                    var getters = Object.keys(mapping).reduce(function (a, key) {
                        var _a;
                        return (__assign(__assign({}, a), (_a = {}, _a[key] = offeringPane.querySelector("[data-get=\"".concat(key, "\"]")), _a)));
                    }, {});
                    for (var key in getters) {
                        if (getters[key]) {
                            getters[key].innerHTML = String(mapping[key]);
                        }
                        //other tags that are not part of the mapping table
                        offeringPane.querySelectorAll("[data-term]").forEach(function (a) {
                            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
                            var requested = a.getAttribute('data-term') || '';
                            if ((requested === null || requested === void 0 ? void 0 : requested.length) && (0, get_1.default)(term, requested)) {
                                var value = (0, get_1.default)(term, requested);
                                //console.log("requested (term)", requested, "result", get(term, requested))
                                if (requested === 'paymentFrequencyValue') {
                                    var multiplier_1 = (_e = (_c = (_b = (_a = _this.config.get) === null || _a === void 0 ? void 0 : _a.pricePreview) === null || _b === void 0 ? void 0 : _b.paymentFrequencyMultipliers) === null || _c === void 0 ? void 0 : _c[(_d = term === null || term === void 0 ? void 0 : term.id) === null || _d === void 0 ? void 0 : _d.toString()]) !== null && _e !== void 0 ? _e : 1;
                                    var newVal = value * multiplier_1;
                                    a.innerHTML = translation_1.default.t(newVal === 1 ? 'per ' : newVal.toString());
                                }
                                else if (requested === 'paymentFrequencyUnit') {
                                    var multiplier_2 = (_k = (_h = (_g = (_f = _this.config.get) === null || _f === void 0 ? void 0 : _f.pricePreview) === null || _g === void 0 ? void 0 : _g.paymentFrequencyMultipliers) === null || _h === void 0 ? void 0 : _h[(_j = term === null || term === void 0 ? void 0 : term.id) === null || _j === void 0 ? void 0 : _j.toString()]) !== null && _k !== void 0 ? _k : 1;
                                    var paymentFrequency = term.paymentFrequencyValue;
                                    var newVal = paymentFrequency * multiplier_2;
                                    a.innerHTML = translation_1.default.t(newVal > 1 ? value + 'S' : value);
                                }
                                else if (requested === 'price') {
                                    var multiplier_3 = (_q = (_o = (_m = (_l = _this.config.get) === null || _l === void 0 ? void 0 : _l.pricePreview) === null || _m === void 0 ? void 0 : _m.paymentFrequencyMultipliers) === null || _o === void 0 ? void 0 : _o[(_p = term === null || term === void 0 ? void 0 : term.id) === null || _p === void 0 ? void 0 : _p.toString()]) !== null && _q !== void 0 ? _q : 1;
                                    var adjustment_1 = (_t = (_s = (_r = _this.config.get) === null || _r === void 0 ? void 0 : _r.checkout) === null || _s === void 0 ? void 0 : _s.displayPriceAdjustment) !== null && _t !== void 0 ? _t : 0;
                                    a.innerHTML = translation_1.default.transformCurrency(value * multiplier_3 + adjustment_1);
                                }
                                else {
                                    a.innerHTML = translation_1.default.t(value);
                                } // price, paymentFrequencyUnit
                            }
                        });
                        var offerGetters = offeringPane.querySelectorAll("[data-get]");
                        offerGetters.forEach(function (a) {
                            var requested = a.getAttribute('data-get');
                            if ((requested === null || requested === void 0 ? void 0 : requested.length) && (0, get_1.default)(offering, requested)) {
                                //console.log("requested (membership)", requested, "result", get(offering, requested), "translated", i18n.t(get(offering, requested)))
                                if (requested === 'subDescription') {
                                    _this.createSubDescriptionRefObject(offering.subDescription, (0, cash_dom_1.default)(a));
                                }
                                else if (requested === 'name') {
                                    a.innerHTML = mapping.name;
                                }
                                else {
                                    a.innerHTML = translation_1.default.t((0, get_1.default)(offering, requested)).replace(/\n/g, '<br>');
                                }
                            }
                            else if (!mapping[requested] && requested !== 'item') {
                                // only show if its not an external value from mapping or item (used for subdescription)
                                console.info("Your requested data [data-get]=\"".concat(requested, "\" doesn't exist on "), offering);
                            }
                        });
                    }
                    if (this_1.config.get.environment === 'prod') {
                        if ((offerings === null || offerings === void 0 ? void 0 : offerings.length) === 0) {
                            console.error("You have NO clickable offering panes!! Customer can't choose an offer", 'Make at least one clickable by adding the attribute [data-clickable="true"] to at least one data-membership=\'offerID\' element', getOfferingPanes);
                        }
                        else if (numberOfClickablePanes < (offerings === null || offerings === void 0 ? void 0 : offerings.length)) {
                            console.info('You have more offerings (' +
                                (offerings === null || offerings === void 0 ? void 0 : offerings.length) +
                                ') than clickable panes (' +
                                numberOfClickablePanes +
                                '). You might want to add some [data-clickable="true"] otherwise the customer cant buy some of your offers');
                        }
                        else if (numberOfClickablePanes > (offerings === null || offerings === void 0 ? void 0 : offerings.length)) {
                            console.info('You have less offerings (' +
                                (offerings === null || offerings === void 0 ? void 0 : offerings.length) +
                                ') than clickable panes (' +
                                numberOfClickablePanes +
                                ').. If you have multiple sections where the user can select the contract this might be wanted behaviour');
                        }
                    }
                };
                this_1 = this;
                for (_i = 0, getOfferingPanes_1 = getOfferingPanes; _i < getOfferingPanes_1.length; _i++) {
                    offeringPane = getOfferingPanes_1[_i];
                    _loop_1(offeringPane);
                }
                return [2 /*return*/];
            });
        });
    };
    /**
     * Renders the contracts
     * @param offerings
     */
    Checkout.prototype.renderContracts = function (offerings) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        (0, reference_object_const_1._RemoveAllReferenceClones)(this.module.references);
        for (var _i = 0, offerings_1 = offerings; _i < offerings_1.length; _i++) {
            var offering = offerings_1[_i];
            var terms = offering.terms;
            // Apply slicing if maximumNumberOfTerms is defined and the termSwitcherAttribute is not 'name' or 'recurringOffering'.
            if ((_c = (_b = (_a = this === null || this === void 0 ? void 0 : this.config) === null || _a === void 0 ? void 0 : _a.get) === null || _b === void 0 ? void 0 : _b.checkout) === null || _c === void 0 ? void 0 : _c.maximumNumberOfTerms) {
                terms = terms.slice(0, this.config.get.checkout.maximumNumberOfTerms);
            }
            for (var _j = 0, terms_1 = terms; _j < terms_1.length; _j++) {
                var term = terms_1[_j];
                var isFeatured = this.regularOrFeaturedContract(offering, term);
                var regularContract = (_e = (_d = this.module) === null || _d === void 0 ? void 0 : _d.references) === null || _e === void 0 ? void 0 : _e.regularContract;
                var featuredContract = (_g = (_f = this.module) === null || _f === void 0 ? void 0 : _f.references) === null || _g === void 0 ? void 0 : _g.featuredContract;
                // if we do not generate the membership panels ourself
                if (!(regularContract === null || regularContract === void 0 ? void 0 : regularContract.domElement)) {
                    return;
                }
                var contractElement = isFeatured ? featuredContract : regularContract;
                var clone = contractElement.cloneDomElement([
                    { key: 'data-membership', value: String(offering.id) },
                    { key: 'data-clickable', value: String(true) },
                    { key: 'data-featured', value: String(isFeatured) },
                    { key: 'data-term-id', value: String(term.id) },
                ], true);
                //fallback we use the div element where the old contracts were
                var contractWrapper = ((_h = this.dataWrapper) === null || _h === void 0 ? void 0 : _h.length) ? this.dataWrapper : contractElement === null || contractElement === void 0 ? void 0 : contractElement.parent;
                contractWrapper.append(clone);
            }
        }
    };
    /**
     * Determines if a given offering or term is a featured or not
     * @param offering
     * @param term
     * @returns
     */
    Checkout.prototype.regularOrFeaturedContract = function (offering, term) {
        var _a, _b, _c, _d, _e, _f, _g;
        if (!((_d = (_c = (_b = (_a = this.module) === null || _a === void 0 ? void 0 : _a.references) === null || _b === void 0 ? void 0 : _b.featuredContract) === null || _c === void 0 ? void 0 : _c.domElement) === null || _d === void 0 ? void 0 : _d.length)) {
            return false;
        }
        console.log('checking featured for term', term);
        if (Array.isArray((_e = this.config.get.checkout) === null || _e === void 0 ? void 0 : _e.featuredTermIds)) {
            if ((_f = this.config.get.checkout) === null || _f === void 0 ? void 0 : _f.featuredTermIds.includes(term.id.toString())) {
                return true;
            }
        }
        if (!((_g = offering.footnote) === null || _g === void 0 ? void 0 : _g.length)) {
            //no features in contract or ui so we defenetly a regular contract
            return false;
        }
        //if the whole offering includes just terms that are featured you can just set the offering as featured
        if (offering.footnote.toLowerCase() === 'featured') {
            return true;
        }
        //Often you only want a specific term to be featured
        //so you type in the footnote e.g. featured:12
        //Than terms with a termValue of 12 are being featured
        if ((offering === null || offering === void 0 ? void 0 : offering.footnote.split(':').length) > 1) {
            var footNoteTermValue = +(offering === null || offering === void 0 ? void 0 : offering.footnote.split(':')[1].replace(/[a-z\s]/gi, ''));
            if (footNoteTermValue) {
                if (term.termValue === footNoteTermValue) {
                    return true;
                }
                // if (this.termSwitcherValue?.length && this.termSwitcherExists) {
                //   if (+this.termSwitcherValue === footNoteTermValue) {
                //     return true;
                //   }
                // }
            }
            else {
                return false;
            }
        }
        return false;
    };
    return Checkout;
}());
exports.Checkout = Checkout;
